<template>
  <div id="app">
    <router-view v-if="isMobile" />
    <div v-else class="desktop">
      <img class="logo" src="./assets/images/logo.svg" alt="logo" />
      <h3>Sorry, Caledonia Pay is only available on mobile devices!</h3>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      maxScreenSize: 700
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < this.maxScreenSize;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: $body-font-family;
  font-size: $base-font-size;
  line-height: $body-font-line-height;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: $background;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-transform: $header-font-case;
  color: $header-color;
  font-family: $header-font-family;
  letter-spacing: $letter-spacing;
  font-weight: $header-font-weight;
  line-height: $header-line-height;
}
.desktop {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-image: linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)),
    url("./assets/images/background.jpg");

  .logo {
    width: 60vw;
    margin-bottom: 3rem;
  }
}
</style>
